import Box from "@mui/material/Box";

export interface CenteredLayoutProps extends React.PropsWithChildren {}

export function CenteredLayout({ children }: CenteredLayoutProps) {
  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
